import { css, html, nothing } from "lit";
import { query, queryAssignedElements } from "lit/decorators.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import "../../atom/Text/index.js";
import "../../atom/Row/index.js";
import "../../atom/Column/index.js";
import "../../atom/ClickOutside/index.js";
import "../ThumbProfile/index.js";
import "../IconButton/index.js";
import "../Popover/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfNavMenu = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_name = "";
    this.dsf_role = "";
    this.dsf_profile_url = "";
    this.dsf_mobile = false;
    this.dsf_mobile_open = false;
  }
  get initials() {
    var _a, _b;
    const [first, ...last] = ((_a = this.dsf_name) == null ? void 0 : _a.trim().split(" ")) || [""];
    return `${(first == null ? void 0 : first.charAt(0)) || ""}${((_b = last == null ? void 0 : last.at(-1)) == null ? void 0 : _b.charAt(0)) || ""}`.toUpperCase();
  }
  onItemClick(e) {
    var _a;
    e.stopPropagation();
    const item = e.target;
    if (item && item.hasContent) {
      return;
    }
    if (this.dsf_mobile) {
      this.dsf_mobile_open = false;
    } else {
      (_a = this.popoverElement) == null ? void 0 : _a.closeAndFocus();
    }
  }
  closeAllItems() {
    var _a;
    (_a = this.navItems) == null ? void 0 : _a.forEach((item) => item.closeMenu());
  }
  popoverOpenChanged() {
    this.closeAllItems();
  }
  toggleMobileOpen() {
    this.dsf_mobile_open = !this.dsf_mobile_open;
    this.emit(this.dsf_mobile_open ? "open" : "close");
    this.closeAllItems();
  }
  onClickOutside() {
    this.dsf_mobile_open = false;
    this.emit("close");
  }
  renderHeader() {
    return html`
      <dsf-row dsf_gap="s" class="dsf-p-m">
        <dsf-thumb-profile>${this.initials}</dsf-thumb-profile>
        <dsf-col>
          <dsf-text dsf_level="s-semibold">${this.dsf_name}</dsf-text>
          ${this.dsf_role ? html`<dsf-text dsf_level="xs" dsf_color_intensity="400">${this.dsf_role}</dsf-text>` : nothing}
        </dsf-col>
        ${this.dsf_mobile ? html`
              <dsf-icon-button
                class=${this.dsf_mobile_open ? "rotate" : nothing}
                dsf_icon="ChevronUp"
              ></dsf-icon-button>
            ` : nothing}
      </dsf-row>
    `;
  }
  renderMobile() {
    return html`
      <dsf-click-outside
        @click-outside=${this.onClickOutside}
        .disabled=${!this.dsf_mobile_open}
        class="mobile grow"
      >
        <dsf-col class="border-t border-neutral-100 bg-neutral-50" @click=${this.toggleMobileOpen}>
          ${this.renderHeader()}
          <dsf-col class=${`dsf-p-s ${this.dsf_mobile_open ? "" : "hidden"}`}>
            <slot @click=${this.onItemClick}></slot>
          </dsf-col>
        </dsf-col>
      </dsf-click-outside>
    `;
  }
  renderDesktop() {
    return html`
      <dsf-popover tabindex="0" dsf_offset_vertical="16" @open-changed=${this.popoverOpenChanged}>
        <dsf-thumb-profile
          slot="anchor"
          dsf_src=${this.dsf_profile_url || nothing}
          class="hover:opacity-90"
        >
          ${this.initials}
        </dsf-thumb-profile>
        ${this.renderHeader()}
        <dsf-row class="w-full border-b border-neutral-100" dsf_grow="1"></dsf-row>
        <dsf-col class="dsf-p-s w-full gap-4">
          <slot @click=${this.onItemClick}></slot>
        </dsf-col>
      </dsf-popover>
    `;
  }
  render() {
    return this.dsf_mobile ? this.renderMobile() : this.renderDesktop();
  }
};
DsfNavMenu.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        width: 100%;
      }

      ::part(anchor) {
        width: fit-content;
        height: fit-content;
        border-radius: 100%;
      }

      .mobile {
        width: 100%;
        flex-grow: 1;
      }

      .rotate {
        transform: rotate(180deg);
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfNavMenu.prototype, "dsf_name", 2);
__decorateClass([
  prop({ type: String })
], DsfNavMenu.prototype, "dsf_role", 2);
__decorateClass([
  prop({ type: String })
], DsfNavMenu.prototype, "dsf_profile_url", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfNavMenu.prototype, "dsf_mobile", 2);
__decorateClass([
  prop({ type: Boolean, attribute: false })
], DsfNavMenu.prototype, "dsf_mobile_open", 2);
__decorateClass([
  query("dsf-popover")
], DsfNavMenu.prototype, "popoverElement", 2);
__decorateClass([
  queryAssignedElements({ selector: "dsf-navbar-item" })
], DsfNavMenu.prototype, "navItems", 2);
DsfNavMenu = __decorateClass([
  defineElement("dsf-nav-menu")
], DsfNavMenu);
export {
  DsfNavMenu
};
